import { CommonGet, CommonPost, CommonGetIDServer, CommonPostIDServer } from "../../../utils/CommonFetch";
import tokenDecoder from '../../Common/tokenDecoder';

export default {
    GetAllCollectionPoints,
    getOperationEntityByID,
    getCollectionPointByOperationEntityId,
    GetAllOperationEntityByGroupID,
    getDuplicateTagData,
    getCustomersFromCollectionPoint,
    editDuplicateData,
    getFieldDeductions,
    getFactoryDeductions,
    getAllDeductions
};

async function getAllDeductions(groupID, operationEntityID,collectionPointID) {
    const response = await CommonGet('/api/DeductionType/GetDeductionTypesByGroupIDEntityIDCollectionPointID', "groupID=" + parseInt(groupID) + "&entityID=" + parseInt(operationEntityID)+ "&collectionPointID=" + parseInt(collectionPointID));
    return response.data;
  }

async function getFactoryDeductions(factoryWeighDetailID) {
    var response = await CommonGet('/api/ProductCollection/GetFactoryDeductions', 'factoryWeighDetailID=' + factoryWeighDetailID);
    return response.data;
}

async function getFieldDeductions(productCollectionDetailsID) {
    var response = await CommonGet('/api/ProductCollection/GetFieldDeductions', 'productCollectionDetailsID=' + productCollectionDetailsID);
    return response.data;
}

async function GetAllCollectionPoints(id, groupID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["operationEntityID"] === parseInt(id) && item[1]["groupID"] === parseInt(groupID) && item[1]["isActive"] === true) {
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;
}

async function GetAllOperationEntityByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + groupID);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]) {
            array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return array;
}

async function getOperationEntityByID(operationEntityID) {
    var response = await CommonGet('/api/OperationEntity/GetOperationEntityByID', 'operationEntityID=' + operationEntityID);
    return response.data;
}

async function getCollectionPointByOperationEntityId(data) {
    var collectionPointArray = [];
    let filterModel = {
        operationEntityID: data.operationEntityID,
        groupID: data.groupID
    }
    var response = await CommonPost('/api/CollectionPoint/GetCollectionPointByOperationEntityId', null, filterModel);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true)
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }
    return collectionPointArray;
}

async function getDuplicateTagData(data) {
    var filtermodel = {
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        collectionPointID: parseInt(data.collectionPointID),
        customerID: parseInt(data.customerID),
        date: data.date
    }
    const response = await CommonPost('/api/ProductCollection/GetDuplicateTagDetails', null, filtermodel);
    return response.data;
}

async function getCustomersFromCollectionPoint(collectionPoint) {
    const response = await CommonGet('/api/Customer/GetAllCustomerbyCollectionPointID', 'collectionPointID=' + collectionPoint)
    return response.data;
}

async function editDuplicateData(data) {
    const response = await CommonPost('/api/ProductCollection/UpdateDuplicateData', null, data);
    return response;
}


